interface GetZoomableContainerWidthProps {
  fitToWidth?: boolean
  isLoading: boolean
  orientation: 'portrait' | 'landscape'
}

export const getZoomableContainerWidth = ({ fitToWidth, isLoading, orientation }: GetZoomableContainerWidthProps) => {
  switch (true) {
    case isLoading:
      return 'auto'
    case fitToWidth:
    case orientation === 'landscape':
      return '100%'
    default:
      return 'fit-content'
  }
}
